<template>
  <div class="sidebar" :class="{'open':isOpen}">
    <div class="row row-top">
      <div class="col-2 text-right">
        <span @click="openFullscreen" class="sidebar-full"><i class="fa fa-expand"></i></span>
      </div>
      <div class="col-8"></div>
      <div class="col-2 text-left">
        <span @click="closeSidebar" class="sidebar-close"><i class="fa fa-times"/></span>
      </div>
    </div>
    <div v-if="user || resultsOnly" class="sidebar-user">
      <div class="row" v-if="displayName && !resultsOnly">
        <div class="col-3"></div>
        <div class="col-9 text-right">
          <span>{{ he ? 'שלום ' : 'Hello, ' }}</span><span>{{ displayName }}</span>
        </div>
      </div>
      <div :class="{disabled: !allowEdit && !resultsOnly}" class="row mt-4">
        <div class="col-12 category">
          <div @click="() => {tvMode ? selectCategory(c): editCategory(c)}"
               :class="{'selected-category': c.id===selectedCategoryId}"
               :style="{'background-image': 'url('+(c.images[c.img])+')'}"
               :key="'c-'+k"
               class="category-item"
               v-for="(c,k) in categories.filter((cat)=> {return !!cat;})">
            <div class="category-counter">{{ categoryPlayers[k] }}</div>
          </div>
        </div>
      </div>
      <div v-if="!resultsOnly">
        <div :class="{disabled: !allowEdit}" class="row my-3">
          <div class="col-4">
            <button class="btn btn-warning btn-md btn-block" id="choose-background"><i
                class="fa fa-image"></i> רקע
            </button>
            <avatar-cropper
                @uploaded="handleUploadedBg"
                trigger="#choose-background"
                upload-url="https://ivote.tv/api/"
                :upload-form-data="{userId:user.id}"
                :output-quality="0.99"
                :cropper-options="{aspectRatio: 0.66, zoomable: true}"
                :output-options="{width: 500, height: 750}"
                :labels="{ submit: 'אישור', cancel: 'ביטול'}"/>
          </div>
          <div class="col-8">
            <button class="btn btn-success btn-md btn-block" @click="addCategory">{{
                trans('btn_add_category')
              }}
            </button>
          </div>
        </div>
        <div :class="{disabled: !allowEdit}" class="row row-settings">
          <div class="col-6 flex-apart mb-1">
            <label>{{ trans('language') }}</label>
            <toggle-button :value="he" @change="updateHe"
                           color="#28a745"
                           switch-color="#ffffff"
                           :font-size="16"
                           :width="72"
                           :labels="{checked: 'עברית', unchecked: 'English'}"/>
          </div>
          <div class="col-6 flex-apart mb-1">
            <label>תצוגה</label>
            <toggle-button :value="tvMode" @change="updateTvMode"
                           color="#28a745"
                           switch-color="#ffffff"
                           :font-size="16"
                           :width="72"
                           :labels="{checked: 'תוצאות', unchecked: 'מובייל'}"/>
          </div>
        </div>
        <div :class="{disabled: !allowEdit}" class="row row-settings">
          <div class="col-6 flex-apart mb-1">
            <label>הצבעה</label>
            <toggle-button v-model="settings.allowVote"
                           color="#28a745"
                           switch-color="#ffffff"
                           :font-size="16"
                           :width="72"
                           :labels="{checked: 'פתוחה', unchecked: 'סגורה'}"/>
          </div>
          <div class="col-6 flex-apart mb-1">
            <label>אימות בSMS</label>
            <toggle-button v-model="settings.smsVote"
                           color="#28a745"
                           switch-color="#ffffff"
                           :font-size="16"
                           :labels="{checked: 'כן', unchecked: 'לא'}"/>
          </div>
        </div>
        <!--      <div :class="{disabled: !allowEdit}" class="row row-settings">-->
        <!--        <div class="col-6 flex-apart mb-1">-->
        <!--          <label>רשימה סגורה</label>-->
        <!--          <toggle-button v-model="locked"-->
        <!--                         color="#28a745"-->
        <!--                         switch-color="#ffffff"-->
        <!--                         :font-size="16"-->
        <!--                         :width="72"-->
        <!--                         :labels="{checked: 'נעול', unchecked: 'פתוח'}"/>-->
        <!--        </div>-->
        <!--        <div class="col-6 flex-apart mb-1">-->
        <!--          <label>CSV</label>-->
        <!--          <input type="file" accept="text/csv"/>-->
        <!--        </div>-->
        <!--      </div>-->
        <div :class="{disabled: !allowEdit}" class="row row-settings">
          <div class="col-6 flex-apart text-right">
            <label>תוצאות</label>
            <toggle-button v-model="settings.showScore"
                           color="#28a745"
                           switch-color="#ffffff"
                           :font-size="16"
                           :width="72"
                           :labels="{checked: 'פעיל', unchecked: 'כבוי'}"/>
          </div>
          <div class="col-6 flex-apart text-right">
            <label>כותרות</label>
            <toggle-button v-model="settings.hideTitles"
                           color="#28a745"
                           switch-color="#ffffff"
                           :font-size="16"
                           :width="72"
                           :labels="{checked: 'החבא', unchecked: 'הצג'}"/>
          </div>
        </div>
        <div :class="{disabled: !allowEdit}" class="row row-settings">
          <div class="col-6 flex-apart text-right">
            <label>כפתור התחל</label>
            <toggle-button v-model="settings.startButton"
                           color="#28a745"
                           switch-color="#ffffff"
                           :font-size="16"
                           :labels="{checked: 'הצג', unchecked: 'החבא'}"/>
          </div>
          <div class="col-6 flex-apart text-right">
            <label>שיתוף תוצאות</label>
            <a :href="resultsUrl" class="text-white" target="_blank">טאב חדש</a>
          </div>
          <!--        <div class="col-6 flex-apart text-right">-->
          <!--          <label>הצבעה 1-1</label>-->
          <!--          <toggle-button v-model="settings.vote1for1"-->
          <!--                         color="#28a745"-->
          <!--                         switch-color="#ffffff"-->
          <!--                         :font-size="16"-->
          <!--                         :labels="{checked: 'כן', unchecked: 'לא'}"/>-->
          <!--        </div>-->
          <!--        <div class="col-4 flex-apart text-right">-->
          <!--          <label>כותרות</label>-->
          <!--          <toggle-button v-model="settings.hideTitles"-->
          <!--                         color="#28a745"-->
          <!--                         switch-color="#ffffff"-->
          <!--                         :font-size="16"-->
          <!--                         :width="72"-->
          <!--                         :labels="{checked: 'החבא', unchecked: 'הצג'}"/>-->
          <!--        </div>-->
        </div>
        <div :class="{disabled: !allowEdit}" class="row row-settings">
          <div class="col-6 mb-3">
            <label>מועמדים לבחירה</label>
          </div>
          <div class="col-2 mb-3">
            <input class="p-0 text-center" type="number" :max="settings.maxPlayers" v-model="settings.minPlayers">
          </div>
          <div class="col-2   mb-3">
            <label> עד </label>
          </div>
          <div class="col-2 mb-3">
            <input class="p-0 text-center" type="number" :min="settings.minPlayers" v-model="settings.maxPlayers">
          </div>
          <div class="col-4 mb-3">
            <label>איכות תמונה</label>
          </div>
          <div class="col-2 mb-3">
            <select v-model="imgQuality" class="text-right">
              <option :key="i" :value="q.value" v-for="(q,i) in qualities">{{ q.name }}</option>
            </select>
          </div>
          <div class="col-3 mb-3">
            <label>פריסה</label>
          </div>
          <div class="col-3 mb-3">
            <select v-model="selectedCard" class="text-right">
              <option :key="'card-'+c" :value="c" v-for="(c) in cards">{{ c }}</option>
            </select>
          </div>
          <div class="col-6 mb-3">
            <label>{{ trans('theme') }}</label>
          </div>
          <div class="col-4 mb-3">
            <input v-model="settings.theme" style="direction: ltr;text-align: left" type="text"
                   :placeholder="trans('theme')">
          </div>
          <div class="col-2 mb-3 text-left">
            <div class="color-preview" :style="{'background-color': settings.theme }"></div>
          </div>
          <div class="col-12 mb-3">
            <input v-model="settings.message" :placeholder="trans('message')">
          </div>
          <div class="col-12 mb-3">
            <input v-model="settings.support" type="tel" :placeholder="trans('support')">
          </div>
          <div class="col-6 text-left">
            <label class="btn btn-primary btn-block">{{ trans('voted') + ' ' + votesCount }}</label>
          </div>
          <div class="col-6 text-left">
            <button v-if="tvMode" @click="openLeadersBoard" class="btn btn-primary btn-block">{{
                trans('leaders')
              }}
            </button>
            <button v-else @click="openGuests" class="btn btn-primary btn-block">{{
                trans('signedPlayers') + ' ' + guestsCount
              }}
            </button>
          </div>
        </div>
        <div :class="{disabled: !allowEdit}" class="row row-save">
          <!--        <div class="col-6 mb-3">-->
          <!--          <button class="btn btn-warning btn-block">לוגו חברה</button>-->
          <!--        </div>-->
          <div class="col-6 mb-3">
            <button class="btn-save btn btn-success btn-block" @click="saveSettings">{{ trans('save') }}</button>
          </div>
          <div class="col-3 mb-3">
            <button class="btn btn-danger btn-block" @click="resetVotes">{{ trans('reset') }}</button>
          </div>
          <!--        <div class="col-3 mb-3">-->
          <!--          <button class="btn btn-warning btn-block" @click="showQR=true">QR</button>-->
          <!--        </div>-->
          <div class="col-3 mb-3">
            <button class="btn btn-danger btn-block" @click="deleteVote"><i class="fa fa-trash"></i></button>
          </div>
          <div class="col-9">
            <transition name="fade">
              <div class="qr my-3" v-if="showQR">
                <img alt="QR" :src="'https://www.quizygame.com/php/qrRequest.php?id='+voteId" width="256" height="256">
                <button class="btn btn-danger" @click="showQR=false">{{ trans('close') }}</button>
              </div>
            </transition>
          </div>
        </div>
        <div class="row row-votes-list">
          <div class="col-12">
            <hr>
          </div>
          <div class="col-6" :key="my.id"
               v-for="my in votesList">
            <div class="vote-card" :class="{'vote-card-selected':my.code === code}">
              <a :href="'https://ivote.tv/v/'+my.code">
                <strong>{{ my.settings.title }}</strong>
                {{ my.email }}
              </a>
            </div>
          </div>
          <div class="col-12 text-center" v-if="votesList.length===0">
            <p>אין ארועים בחשבון שלך</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <button class="btn btn-danger btn-block" @click="logout">{{ trans('logout') }}</button>
          </div>
          <div class="col-6">
          </div>
          <div class="col-2">
            <button class="btn btn-success" @click="createNew"><i class="fa fa-plus"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="sidebar-login">
      <div class="row row-settings">
        <div class="col-12 text-left mb-5">
          <img alt="Vote Background" src="/img/iVOTE@2x.png"
               width="auto"
               height="32"/>
        </div>
        <div class="col-6">
          <label>{{ trans('language') }}</label>
        </div>
        <div class="col-6">
          <toggle-button :value="he" @change="updateHe"
                         color="#28a745"
                         switch-color="#ffffff"
                         :font-size="16"
                         :width="72"
                         :labels="{checked: 'עברית', unchecked: 'English'}"/>
        </div>
        <div class="col-6 mt-4 text-right">
          <label v-if="settings.support">{{ trans('support') }}</label>
        </div>
        <div class="col-6 mt-4 text-right">
          <a class="text-white" v-if="settings.support" target="_blank"
             :href="'https://wa.me/'+settings.support"><img alt="Whatsapp" src="/img/WhatsApp.svg" width="24"
                                                            height="24"></a>
        </div>
        <div class="col-12">
          <h3 class="mt-5 mb-2">כניסה למנהלים</h3>
          <form>
            <input class="text-right" title="שם משתמש" type="email" v-model="email"
                   placeholder='שם משתמש או דוא"ל'/>
            <input class="text-right" @input="error=''" title="סיסמה" type="password" v-model="pass"
                   placeholder='סיסמה'/>
          </form>
          <div class="row">
            <div class="col-6">
              <button class="btn btn-success" :disabled="!email || !pass" @click="login">למנהלים בלבד</button>
            </div>
            <div class="col-6 text-left">
              <button class="btn btn-danger" @click="resetGuest">איפוס משתמש</button>
              <!--                  <button class="btn btn-danger btn-sm" @click="checkCodeTest">איפוס בדיקה</button>-->
            </div>
          </div>
          <p class="error">{{ error }}</p>
        </div>
        <div class="credits">
          <h5 class="text-center">Powered by <a href="https://he.playzone.co.il/vote" target="_blank">playzone.co.il</a>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.min";
import {ToggleButton} from 'vue-js-toggle-button'
import AvatarCropper from "vue-avatar-cropper"

export default {
  name: "SideBar",
  props: ['isOpen', 'user', 'categories', 'players', 'settings', 'votesCount', 'votesList', 'voteId', 'allowEdit', 'accessToken', 'resultsOnly', 'imgQuality', 'tvMode', 'he', 'locals', 'selectedCategoryId', 'code', 'guestsCount', 'locked'],
  components: {ToggleButton, AvatarCropper},
  data() {
    return {
      email: null,
      pass: null,
      error: '',
      advanced: false,
      cards: [10, 15, 28, 45, 84],
      resolutions: ['1920X1080', '1366X768'],
      selectedCard: 15,
      selectedResolution: '1920X1080',
      showQR: false,
      qualities: [
        {value: 0.6, name: 'נמוכה'},
        {value: 0.8, name: 'בינונית'},
        {value: 0.99, name: 'גבוהה'},
      ]
    }
  },
  mounted() {
  },
  computed: {

    categoryPlayers() {
      let categoryPlayers = {};
      this.categories.filter((cat) => {
        return !!cat;
      }).map((cat, k) => {
        categoryPlayers[k] = this.players.filter((p) => cat.players.includes(p.id)).length;
      });
      return categoryPlayers;
    },
    displayName() {
      return this.user && this.user.name ? this.user.name.split(" ")[0] : "";
    },
    resultsUrl() {
      return `https://ivote.tv/access/${this.code}/${this.accessToken}`;
    }
  },
  methods: {
    addCategory() {
      this.$emit('addCategory');
    },
    editCategory(category) {
      this.$emit('editCategory', category);
    },
    selectCategory(category) {
      this.$emit('selectCategory', category);
    },
    closeSidebar() {
      this.$emit('closeSidebar', true);
    },
    openLeadersBoard() {
      this.$emit('openLeadersBoard', true);
    },
    openGuests() {
      this.$emit('openGuests', true);
    },
    login() {
      let self = this;
      $.ajax({
        url: "https://ivote.tv/api/",
        data: JSON.stringify({email: this.email, pass: this.pass}),
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Action', 'login');
        },
        success: function (response) {
          if (response.id) {
            self.$parent.user = response;
            localStorage.setItem('user', JSON.stringify(response));
            self.$parent.getVote();
          } else {
            self.pass = null;
            self.error = "התחברות לא צלחה";
          }
        },
        dataType: 'json',
        contentType: 'application/json'
      });
    },
    logout() {
      localStorage.removeItem('user');
      this.$emit('logout');
    },
    resetVotes() {
      this.$emit('resetVotes');
    },
    handleUploadedBg(resp) {
      if (resp.status) {
        this.settings.background = resp.url;
        this.$emit('saveSettings');
      }
    },
    checkCodeTest() {
      this.$emit("checkCodeTest");
    },
    createNew() {
      this.$emit('createNew');
    },
    deleteVote() {
      this.$emit('deleteVote');
    },
    getQR() {
      this.$emit('getQR');
    },
    saveSettings() {
      this.$emit('saveSettings', true);
    },
    openFullscreen() {
      this.$emit('openFullscreen')
    },
    resetGuest() {
      localStorage.removeItem('guest');
      location.reload();
    },
    autoSet() {
      if (this.selectedResolution === "1920X1080" || this.selectedResolution === "1366X768") {
        switch (this.selectedCard) {
          case 10:
            this.settings.cols = 5;
            this.settings.rows = 2;
            break;
          case 15:
            this.settings.cols = 5;
            this.settings.rows = 3;
            break;
          case 28:
            this.settings.cols = 7;
            this.settings.rows = 4;
            break;
          case 45:
            this.settings.cols = 9;
            this.settings.rows = 5;
            break;
          case 84:
            this.settings.cols = 12;
            this.settings.rows = 7;
            break;
        }
      }
    },
    updateTvMode: function (value) {
      if (value && this.selectedCategoryId === -1)
        this.selectCategory(this.categories[0]);
      this.$emit('updateTvMode', value);
    },
    updateHe: function (value) {
      this.$emit('updateHe', value);
    },
    trans: function (key) {
      if (!this.locals[key]) return key;
      return this.locals[key][this.he ? 'he' : 'en'];
    }
  },
  watch: {
    selectedCard() {
      this.autoSet();
    },
    selectedResolution() {
      this.autoSet();
    }
  }
}
</script>
<style scoped lang="scss">
.sidebar {
  width: 420px;
  max-width: 90vw;
  height: 100%;
  overflow-y: auto;
  position: fixed;
  top: 0;
  padding: 25px;
  right: -421px;
  transition: right 0.5s ease-in-out;
  background: #222222;
  color: whitesmoke;
  text-align: right;
  z-index: 99;
  box-shadow: 0 -2px 6px 2px #000;

  .sidebar-close, .sidebar-full {
    padding: 2px;
    cursor: pointer;
    font-size: 20px;
  }

  .sidebar-login {
    padding-top: 20px;
    padding-bottom: 40px;
  }

  .sidebar-login input {
    background: none;
    border: none;
    border-bottom: 1px solid #c6c8ca;
    width: 100%;
    margin-bottom: 15px;
    color: white;
  }

  .sidebar-login input::placeholder {
    color: white;
  }

  .selected-category {
    box-shadow: inset 0 0 12px 4px goldenrod;
  }

  input {
    padding: 4px 8px;
  }

  .error {
    color: var(--color-red);
  }

  h3 {
    color: whitesmoke;
    margin-bottom: 0;
    font-size: 24px;
  }

  .row-top, .row-bottom {
    direction: rtl;
    margin-bottom: 10px;
  }

  .row-settings {
    margin-top: 20px;
    margin-bottom: 20px;
    direction: rtl;
  }

  hr {
    border: 1px solid var(--color-purple-trans);
    margin: 12px 0;
  }

  select {
    background: transparent;
    border: none;
    border-bottom: 1px solid whitesmoke;
    color: whitesmoke;
    outline: none;
  }

  select option {
    background: #222222;
  }

  input {
    width: 100%;
    background: transparent;
    color: white;
    border: none;
    border-bottom: 1px solid white;
    text-align: right;
    outline: grey;
  }

  .top-players {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .players-item {
    width: 6rem;
    height: 6rem;
    margin-right: 0.25rem;
    display: inline-block;
  }

  .players-item-selected {
    outline: 3px solid var(--color-main);
    outline-offset: -1px;
  }

  .players-item .player-score {
    border-radius: 100%;
    background: var(--color-main);
    color: white;
    border: 2px solid white;
    position: absolute;
    left: 2px;
    top: 2px;
    width: 32px;
    height: 32px;
    text-align: center;
    padding: 0;
    z-index: 20;
  }

  .players-item .player-score strong {
    display: block;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: -1px;
  }

  .row-save {
    margin-top: 20px;
    direction: rtl;
  }

  .row-save a {
    color: var(--color-red);
  }

  .btn-new {
    position: absolute;
    right: 25px;
    bottom: 25px;
  }

  .row-votes-list {
    direction: rtl;
    height: fit-content;
    overflow-y: auto;
  }

  .row-votes-list a {
    color: whitesmoke;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.75;
  }

  .qr {
    > * {
      width: 100%;
      height: auto;
    }

    > .btn {
      margin-top: 10px;
    }
  }

  label {
    margin: 0;
  }

  &.open {
    right: 0;
  }

  .category {
    .category-item {
      height: 40vw;
      @media (min-width: 768px) {
        height: 180px;
      }
    }

    .category-counter {
      position: absolute;
      top: 0;
      right: 0;
      background: var(--color-purple);
      color: white;
      padding: 2px 4px;
      border-radius: 0 0 0 8px;
    }
  }

  .vote-card {
    padding: 6px;
    text-align: left;
    border-radius: 8px;
    background-color: var(--color-purple);
    margin: 4px 0;
    font-size: 14px;
    word-break: break-word;

    &.vote-card-selected {
      background-color: var(--color-green);
    }

    a {
      text-underline: none;
    }
  }
}

.color-preview {
  border-radius: 100%;
  height: 24px;
  width: 24px;
  margin-top: 4px;
}

.credits {
  position: absolute;
  bottom: 10px;
  width: 100%;
}
</style>
